<script>
  import copy from "../data/doc.json";
  import { progress } from "../stores/global.js";

  $: visible = $progress > 0.99;
</script>

<div class="end" class:visible>
  <p>{copy.end}</p>
  <p><a href="{copy.endLink}">{copy.endCTA}</a></p>
</div>

<style>
  div {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20em;
    z-index: var(--z-top);
    opacity: 0;
    pointer-events: none;
    background-color: var(--base-gray-dark);
    color: var(--base-white);
    box-shadow: 0 0 5px 10px rgba(0, 0, 0, 0.75);
    padding: 0.25em 1em;
    font-size: 16px;
    transform: translate(-50%, 0%);
    transition: all 500ms ease-out;
  }

  div.visible {
    opacity: 1;
    transform: translate(-50%, -50%);
    pointer-events: auto;
  }

  p {
    font-size: 16px;
    text-align: center;
  }
</style>
